import { render, staticRenderFns } from "./VueRecordAudio.vue?vue&type=template&id=39ac1dc6&lang=html&"
import script from "./VueRecordAudio.vue?vue&type=script&lang=js&"
export * from "./VueRecordAudio.vue?vue&type=script&lang=js&"
import style0 from "./VueRecordAudio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports